<script setup>
import { ref } from 'vue';
import Typography from '@components/Typography.vue';
import { useLoading } from '@composables/useLoading';
import { Requests } from '@tools/requests';
import { flashBagError } from '@tools/flashbag';
import { trans, transchoice } from '@elements/translation';
import RealEstateSummary from '@organisms/contact/RealEstateSummary.vue';
import ContactForm from '@organisms/contact/ContactForm.vue';
import SpacePromises from '@organisms/page-space/contact/components/SpacePromises.vue';
import SpaceHelper from '@organisms/page-space/contact/components/SpaceHelper.vue';
import ReturnLink from '@organisms/contact/ReturnLink.vue';
import { getXhrPageSpaceContactUrl } from '@organisms/page-space/contact/routes/routes';

const { pageSpaceUrl } = window;

const summary = ref(window.summary);

const emit = defineEmits([ 'next-step' ]);

const { isLoading, startLoading, stopLoading } = useLoading();

const handleSubmit = async ({ form }) => {
  startLoading();

  try {
    await Requests.post(getXhrPageSpaceContactUrl({ pageSpaceId: summary.value.pageSpaceId }), form);

    emit('next-step');
  } catch (e) {
    flashBagError();
  }

  stopLoading();
};
</script>

<template>
  <div class="page-contact-form space-contact">
    <div class="space-contact__header">
      <ReturnLink
        :link="pageSpaceUrl"
        class="space-contact__return-link"
      />

      <h1 class="space-contact__title">
        {{ trans('space.contact.title') }}
      </h1>
    </div>

    <SpaceHelper class="space-contact__helper--mobile" />

    <div class="space-contact__content">
      <div class="space-contact__info">
        <div class="space-contact__summary">
          <RealEstateSummary
            :title="summary.title"
            :media="summary.media"
          >
            <Typography
              v-if="summary.meeting_rooms"
              variant="body-small"
              color="gray-darker"
            >
              {{ transchoice('space.contact.summary.meeting_rooms', { count: summary.meeting_rooms }) }}
            </Typography>

            <Typography
              v-if="summary.phoneboxes"
              variant="body-small"
              color="gray-darker"
            >
              {{ transchoice('space.contact.summary.phoneboxes', { count: summary.phoneboxes }) }}
            </Typography>
          </RealEstateSummary>
        </div>

        <SpacePromises class="space-contact__promises--desktop" />
      </div>

      <div class="space-contact__form-container">
        <SpaceHelper class="space-contact__helper--desktop" />

        <ContactForm
          class="space-contact__form"
          :is-loading="isLoading"
          @submit="handleSubmit"
        />
      </div>

      <SpacePromises class="space-contact__promises--mobile" />
    </div>
  </div>
</template>
